var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "#f4a734",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 150v332h-152.57c-41.925 0-63.974 28.428-66.22 30h-74.42c-2.278-1.594-24.012-30-66.22-30h-152.57v-362h30v332h122.7c46.882 0 72.978 26.451 79.48 30h47.64c6.499-3.548 32.602-30 79.48-30h122.7v-302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.93 433.97c-18.22-7.88-37.93-11.97-58.23-11.97h-92.7v-362h30v302h45c40.88 0 74.32 32.01 75.93 71.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.3 90c-31.774 0-62.377 8.324-89.354 24.241.697 6.814 1.054 13.743 1.054 20.759v316.371c2.009-1.457 4.306-3.072 6.923-4.79 46.316-30.89 78.229-24.581 174.077-24.581v-332z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 437c0-57.897-47.551-105-106-105h-15v-332c74.991 0 121 60.561 121 135z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.a78cddeb372d5ae0110da872ef5885710b33321f9604ac97bf62a469d00e6fd9.svg";
export { ForwardRef as ReactComponent };